export default "__VITE_ASSET__EFXGNARe__"